import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  tap,
  throwError,
} from 'rxjs'

const CREATE_ACTION = 'create'
const UPDATE_ACTION = 'update'
const REMOVE_ACTION = 'destroy'
@Injectable({
  providedIn: 'root',
})
export class ClientNotesServices extends BehaviorSubject<any[]> {
  private data: any[] = []
  constructor(private _http: HttpClient) {
    super([])
  }
  GetClientNotesforviewaccountspg(cid: any): Observable<object[]> {
    return this._http
      .post<any>(`/api/Clients/getclientnotes`, cid)
      .pipe(catchError(this.handleError))
  }
  /*   SubmitclientNotesforviewaccountspg(clientinfo: any): Observable<object> {
    return this._http.post<any>(`/api/Clients/submitclientnotes`, clientinfo).pipe(catchError(this.handleError));
  } */
  SubmitclientNotesforviewaccountspg(blott: any): Observable<object> {
    return this._http
      .post<any>('/api/Clients/submitclientnotes', blott)
      .pipe(catchError(this.handleError))
  }

  public read() {
    if (this.data.length) {
      return super.next(this.data)
    }

    this.fetch()
      .pipe(
        tap((data) => {
          this.data = data
        }),
      )
      .subscribe((data) => {
        super.next(data)
      })
  }

  public save(data: any, isNew?: boolean) {
    const action = isNew ? CREATE_ACTION : UPDATE_ACTION

    this.reset()

    this.fetch(action, data).subscribe(
      () => this.read(),
      () => this.read(),
    )
  }

  public remove(data: any) {
    this.reset()

    this.fetch(REMOVE_ACTION, data).subscribe(
      () => this.read(),
      () => this.read(),
    )
  }

  public resetItem(dataItem: any) {
    if (!dataItem) {
      return
    }

    // find orignal data item
    const originalDataItem = this.data.find(
      (item) => item.clientId === dataItem.clientId,
    )

    // revert changes
    Object.assign(originalDataItem, dataItem)

    super.next(this.data)
  }

  private reset() {
    this.data = []
  }

  private fetch(action: string = '', data?: any): Observable<any[]> {
    return this._http
      .jsonp(
        `/api/Clients/RetrieveAllclients?${this.serializeModels(data)}`,
        'callback',
      )
      .pipe(map((res) => <any[]>res))
  }

  private serializeModels(data?: any): string {
    return data ? `&models=${JSON.stringify([data])}` : ''
  }

  handleError(error) {
    let errorMessage = ''
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`
    }
   // console.log(errorMessage)
    return throwError(errorMessage)
  }
}
